import SliderRange from './SliderRange.vue';

export default SliderRange;
